import { Injectable } from '@angular/core';
import { Actions, ofType, Effect } from '@ngrx/effects';
import { Observable, of, empty } from 'rxjs';
import { exhaustMap, map, switchMap, catchError } from 'rxjs/operators';
import { Action } from '@ngrx/store/src/models';
import {
  StepperActionTypes,
  SendStepperFormSuccess,
  SendStepperFormFail,
  InitDefaultItemIdsSuccess
} from '../../actions/stepper/stepper.actions';
import { StepperService } from '../../services/stepper/stepper.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class StepperEffects {
  @Effect()
  public sendStepperForm(): Observable<Action> {
    return this.actions.pipe(
      ofType(StepperActionTypes.SEND_STEPPER_FORM),
      exhaustMap((action: any) =>
        this.stepperService.sendStepperForm(action.data, action.files).pipe(
          map((response) =>
            SendStepperFormSuccess({
              message: this.translateService.instant('STEPPER_SUCCESS')  +  ': ' + response.id
            })
          ),
          catchError(error => of(SendStepperFormFail({ error })))
        )
      )
    );
  }

  @Effect()
  public initDefaultItemIds() {
    return this.actions.pipe(
      ofType(StepperActionTypes.INIT_DEFAULT_ITEM_IDS),
      exhaustMap(() =>
        this.stepperService.initDefaultItemIds().pipe(
          map(defaultItemIds => InitDefaultItemIdsSuccess({ defaultItemIds })),
          catchError(error => empty())
        )
      )
    );
  }

  constructor(
    private actions: Actions,
    private stepperService: StepperService,
    private translateService: TranslateService
  ) {}
}
